import { HygraphPack } from '@repo/types-client';

/**
 * Retrieves the product ID for a given pack based on the environment.
 * @function getPackProductId
 * @param {HygraphPack | null} pack - The pack object.
 * @returns {string | null} The product ID for the pack.
 */
export const getPackProductId = (pack: HygraphPack | null): string | null => {
  if (!pack) {
    return null;
  }

  return process.env.NEXT_PUBLIC_APP_ENV === 'production'
    ? pack.stripeProductionProductId
    : pack.externalProductId;
};
